import api from '../../axios'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || null,
    user: JSON.parse(localStorage.getItem("user")) || null,
  },
  getters: {
    user: state => state.user,
    isAuthenticated: state => !!state.user, // <-- agregado
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token;
      state.user = user;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    LOGOUT(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      delete api.defaults.headers.common["Authorization"];
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const res = await api.post('/login', credentials)
      commit("SET_AUTH", {
        token: res.data.access_token,
        user: res.data.user,
      });
    },
    async register({ commit }, data) {
      const res = await api.post("/register", data);
      commit("SET_AUTH", {
        token: res.data.access_token,
        user: res.data.user,
      });
    },
    async logout({ commit }) {
      await api.post("/logout");
      commit("LOGOUT");
    },
  },
};
